function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#333",
  strokeDasharray: "1 5",
  strokeWidth: 2,
  d: "M96 191c52.467 0 95-42.533 95-95S148.467 1 96 1 1 43.533 1 96s42.533 95 95 95z"
});

var SvgDashedCircle = function SvgDashedCircle(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 192 192"
  }, props), _ref);
};

export default SvgDashedCircle;